export default {
    home: 'home',
    course: 'course',
    teacher: 'teacher',
    resource: 'resource',
    class: 'class',
    test: 'test',
    experience: 'experience',
    login: 'login',
    register: 'register'
};